<template>
  <div>
    <h4 class="header-tit"><img src="@/assets/head-logo.png" />诚云·工资条</h4>
    <el-row class="tac">
      <transition name="el-fade-in">
        <el-menu :default-active="$route.path" class="el-menu-vertical-demo" router>
          <template v-for="(item,index) in $router.options.routes" v-if="item.meta.keepAlive">
            <el-menu-item @click="handleOpen(item.path)" :class="{'nav-click':$route.meta.index === index}">
                <i :class="item.icon"></i>
                <span slot="title">{{item.name}}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </transition>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: 'NavBar',
    methods: {
      handleOpen(path) {
        this.$router.push(path);
      },
    },
  };
</script>

<style scoped>
  .header-tit{
    font-size:18px;
    background: #2ba5f6;
    line-height:60px;
    margin:0;
  }
  .header-tit img{
    width: 42px;
    vertical-align: middle;
    margin: -8px 5px 0 0;
  }
  .el-menu{
    background:none;
    border-right:none;
    padding-top:30px;
  }
  .el-menu-item,.el-menu-item i{
    color:#fff;
    transition:inherit;
  }
  .el-menu-item:hover,.el-menu-item:link,.el-menu-item:visited,.el-menu-item:active,.el-menu-item:focus,.nav-click{
    background:#4E4E55;
    border-left:6px solid #2ba5f6;
  }
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue